import {
  Handbook as SharedHandbook,
  HandbookHistory as SharedHandbookHistory,
  HandbookStatus as SharedHandbookStatus,
  HANDBOOK_STATUSES as SharedHandbookStatuses,
  ALL_HANDBOOK_STATUSES as SharedAllHandbookStatuses
} from "shared/dist/types/Handbook";

export type HandbookHistory = SharedHandbookHistory;
export type HandbookStatus = SharedHandbookStatus;
export const HANDBOOK_STATUSES = SharedHandbookStatuses;
export const ALL_HANDBOOK_STATUSES = SharedAllHandbookStatuses;

export default interface Handbook extends SharedHandbook {}